/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find out how fast you type. Start typing the text below and your words-per-minute (WPM) and accuracy update live. The test lasts 60 seconds.`)
};

const es_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre qué tan rápido escribes. Empieza a escribir el texto de abajo y tus palabras por minuto (WPM) y precisión se actualizan en vivo. El test dura 60 segundos.`)
};

const de_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finde heraus, wie schnell du tippst. Beginne, den Text unten einzutippen, und deine Wörter pro Minute (WPM) sowie deine Genauigkeit werden live aktualisiert. Der Test dauert 60 Sekunden.`)
};

const nl_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek hoe snel je typt. Begin met het typen van de tekst hieronder en je woorden per minuut (WPM) en nauwkeurigheid worden live bijgewerkt. De test duurt 60 seconden.`)
};

const fr_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez à quelle vitesse vous tapez. Commencez à taper le texte ci-dessous et votre nombre de mots par minute (WPM) ainsi que votre précision se mettent à jour en direct. Le test dure 60 secondes.`)
};

const it_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri quanto velocemente digiti. Inizia a scrivere il testo qui sotto e le tue parole al minuto (WPM) e la precisione si aggiornano in tempo reale. Il test dura 60 secondi.`)
};

const pt_br2_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quão rápido você digita. Comece a digitar o texto abaixo e suas palavras por minuto (WPM) e precisão são atualizadas ao vivo. O teste dura 60 segundos.`)
};

const pt_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra a rapidez com que escreve. Comece a escrever o texto abaixo e as suas palavras por minuto (WPM) e precisão são atualizadas em tempo real. O teste dura 60 segundos.`)
};

const ja_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分のタイピング速度を確認しましょう。下のテキストを入力し始めると、WPM（1分あたりの入力単語数）と正確率がリアルタイムで更新されます。テストの時間は60秒です。`)
};

const zh_typing_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解您的打字速度有多快。开始输入下方文本，您的每分钟字数（WPM）和准确率将实时更新。测试持续60秒。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_intro", locale)
	if (locale === "en") return en_typing_hub_intro(inputs)
	if (locale === "es") return es_typing_hub_intro(inputs)
	if (locale === "de") return de_typing_hub_intro(inputs)
	if (locale === "nl") return nl_typing_hub_intro(inputs)
	if (locale === "fr") return fr_typing_hub_intro(inputs)
	if (locale === "it") return it_typing_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_intro(inputs)
	if (locale === "pt") return pt_typing_hub_intro(inputs)
	if (locale === "ja") return ja_typing_hub_intro(inputs)
	return zh_typing_hub_intro(inputs)
};